import axios from 'axios';

const backend_endpoint = process.env.REACT_APP_BACK_END_ENDPOINT ?? '';

console.log('Configured backend endpoint is ' + backend_endpoint);

export async function getTokenOrRefresh(accessToken) {
  const speechToken = sessionStorage.getItem('speech-token');

  function isTokenExpired(token) {
    try {
      const payloadBase64 = token.split('.')[1];
      const payloadJson = JSON.parse(atob(payloadBase64));
      const exp = payloadJson.exp;
      const nowUtc = Math.floor(Date.now() / 1000);
      return exp < nowUtc;
    } catch (error) {
      console.error("Token decoding failed:", error);
      return true; 
    }
  }

  if (!speechToken || isTokenExpired(speechToken.split(':')[1])) {
    try {
      console.log('Fetching new token from backend...');
      const endpoint = backend_endpoint 
        ? `${backend_endpoint}/api/speech/token` 
        : '/api/speech/token';

      const res = await axios.get(endpoint, { 
                headers: { 
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type':'application/json'
                }
            });
      const token = res.data.speechToken;
      const region = res.data.region;

      sessionStorage.setItem('speech-token', `${region}:${token}`);
      console.log('New token stored:', token);

      return { authToken: token, region: region };
    } catch (err) {
      console.error('Token fetch failed:', err);
      return { authToken: null, error: err.response?.data };
    }
  } else {
    const idx = speechToken.indexOf(':');
    return {
      authToken: speechToken.slice(idx + 1),
      region: speechToken.slice(0, idx)
    };
  }
}

export async function getKeyPhrases(requestText, accessToken) {      
    try{
        if (!requestText) {
            // strValue was empty string, false, 0, null, undefined, ...
            return {data: "Request text cant be empty"};
        }
        //Key Phrase extraction
        const data = {transcript: requestText};
        const headers = { 'Authorization': `Bearer ${accessToken}`,'Content-Type': 'application/json' };
        const res = await axios.post(backend_endpoint + '/api/azure/language/ta-key-phrases', data, {headers});  
        return res.data;     
    } catch (err) {       
        return {keyPhrasesExtracted: "NoKP", entityExtracted: "NoEnt"};
    }
}

export async function getGPT3CustomPromptCompletion(requestText, customPrompt, accessToken) {      
    try{
        if (!requestText || !customPrompt) {
            // strValue was empty string, false, 0, null, undefined, ...
            return {data: "Request text and Custom Prompt can't be empty"};
        }
        
        //GPT-3 prompt completion
        const data = {transcript: requestText, customPrompt: customPrompt};
        const headers = { 'Authorization': `Bearer ${accessToken}`,'Content-Type': 'application/json' };
        const res = await axios.post(backend_endpoint + '/api/openai/gpt/customPrompt', data, {headers});
        return res;
    } catch (err) {       
        return {data: "Error occured while invoking Azure OpenAI API, please try again" + err.message};
    }
}

export async function getGPT3DiarizationPromptCompletion(requestText, customPrompt, accessToken) {      
    try{
        if (!requestText || !customPrompt) {
            // strValue was empty string, false, 0, null, undefined, ...
            return {data: "Request text and Custom Prompt can't be empty"};
        }

        //GPT-3 prompt completion
        const data = {transcript: requestText, customPrompt: customPrompt};
        const headers = { 'Authorization': `Bearer ${accessToken}`,'Content-Type': 'application/json' };
        const res = await axios.post(backend_endpoint + '/api/openai/gpt/DiarizationPrompt', data, {headers});
        return res;
    } catch (err) {       
        return {data: "Error occured while invoking Azure OpenAI API, please try again" + err.message};
    }
}

export async function getGPT3Summarize(
    existingSummary,
    newTranscriptText,
    accessToken
) {
    try {

        if (!newTranscriptText) {
            return {
                data: "No new transcript text to summarize"
            };
        }

        const data = {
            existingSummary,
            newTranscriptText
        };

        const headers = {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        };

        const res = await axios.post(
            backend_endpoint + '/api/openai/gpt/summarize',
            data,
            { headers }
        );

        return res;

    } catch (err) {

        console.error(
            "GPT summarization failed",
            err
        );

        return {
            data: "No data from GPT summarize"
        };
    }
}

export async function getGPT3ParseExtractInfo(requestText, conversationScenario) {      
    try{
        if (!requestText || !conversationScenario) {
            // strValue was empty string, false, 0, null, undefined, ...
            return {data: "Request text and Conversation Scenario can't be empty"};
        }
        //GPT-3 Parse extract info using the completion API 
        const data = {transcript: requestText, parsePromptCategory: conversationScenario};
        const headers = { 'Content-Type': 'application/json' };
        const res = await axios.post(backend_endpoint + '/api/openai/gpt/parseExtractInfo', data, {headers});                
        return res;
    } catch (err) {       
        return {data: "No data from GPT Parse extract info"};
    }
}
